export default "__VITE_ASSET__BxddJiSg__"